<!--
  ~ Copyright 2023-2024 Aion Technology LLC
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~     http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<ms-session-container title="Sign in with your email and password" width="650px" height="425px">
  <form class="form-signin" method="POST">
    <div class="row-container">
      <mat-form-field appearance="outline" class="input-field">
        <mat-label>Email</mat-label>
        <input matInput required type="email" maxlength="100" [(ngModel)]="email"
               [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </div>
    <div class="row-container">
      <mat-form-field appearance="outline" class="input-field">
        <mat-label>Password</mat-label>
        <input matInput required type="password" maxlength="25" [(ngModel)]="password"
               [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </div>
    <div class="row-container">
      <a [routerLink]="['/reset-password']" class="mat-body-1">Forgot Password?</a>
    </div>
    <div class="row-container">
      <button class="submit mat-body-1" (click)="onLogin()" type="submit">
        Log In
      </button>
    </div>
    <div *ngIf="errorMessage != null" class="row-container">
      <span class="error mat-body-2">{{ errorMessage }}</span>
    </div>
  </form>
</ms-session-container>
